import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { mockVnGoldHistory } from '@/mocks/vnGoldPrices';

export interface VnGoldHistory {
  id: string;
  type_code: string;
  name: string;
  buy: number;
  sell: number;
  change_buy: number;
  change_sell: number;
  change_percent: number;
  record_date: string;
  created_at: string;
}

export function useVnGoldHistory(typeCode: string, days = 30) {
  const [data, setData] = useState<VnGoldHistory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isMockData, setIsMockData] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function fetchHistory() {
      try {
        setLoading(true);
        setError(null);
        setIsMockData(false);

        const since = new Date();
        since.setDate(since.getDate() - days);
        const sinceStr = since.toISOString().split('T')[0];

        const { data: rows, error: dbError } = await supabase
          .from('vn_gold_history')
          .select('*')
          .eq('type_code', typeCode)
          .gte('record_date', sinceStr)
          .order('record_date', { ascending: true });

        if (dbError) throw dbError;

        const history = (rows || []) as VnGoldHistory[];

        if (!cancelled) {
          if (history.length === 0) {
            const fallback = mockVnGoldHistory[typeCode] || [];
            setData(fallback);
            setIsMockData(fallback.length > 0);
          } else {
            setData(history);
            setIsMockData(false);
          }
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Lỗi tải lịch sử giá');
          const fallback = mockVnGoldHistory[typeCode] || [];
          setData(fallback);
          setIsMockData(fallback.length > 0);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    if (typeCode) {
      fetchHistory();
    }

    return () => { cancelled = true; };
  }, [typeCode, days]);

  return { data, loading, error, isMockData };
}